import styled from 'styled-components';
import colors from '../../assets/colors';

export const Container = styled.div`
  float: right;
  position: relative;
  z-index: 9999;
  top: ${props => (!props.orderPadding ? '50px' : '91px')};
  background: #FFF; 
  border-radius: 8px;
  border: 1px solid #DDDDDD;


  @media screen and (max-width: 620px) {
    top: ${props => (props.ratingPadding && '118px')}
  }

  @media screen and (max-width: 490px) {
    top: ${(props) => {
    if (!props.ratingPadding && !props.orderPadding) return '100px';
    if (!props.ratingPadding && props.orderPadding) return '143px';
    return '118px';
  }};
  }
`;

export const Content = styled.div`
  padding-top: 8px;
  font-size: 0.85rem;
  cursor: context-menu;

  .links {
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0;
    -webkit-touch-callout: none; 
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 

    li {
      padding: 10px 15px;

      :hover { background-color: #F9F9F9; }
    }

    li.active {
      background-color: ${colors.primary};
      color: ${colors.white};
    }
  }

  .date-container {
    padding: 15px 15px;
    margin-top: 8px;
    background-color: #F9F9F9;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    p {
      font-size: 0.9rem;
      font-weight: 700;
      color: #999;
      padding-bottom: 10px;
      letter-spacing: -0.5px;
    }

    .row {
      display: flex;

      input {
        width: 75px;
        margin-bottom: 0;

        :first-child { margin-right: 15px; }
      }
    }

    button {
      width: 100%;
      padding: 10px 0;
      margin-top: 18px;
      background: ${colors.primary};
      background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
      border: none;
      border-radius: 100px;
      text-transform: uppercase;
      font-size: 0.9rem;
      font-weight: 600;
      color: ${colors.white};
      font-family: 'Open Sans', sans-serif;
      outline: none;
      cursor: pointer;

      :hover { opacity: .9 }
    }
  }

  @media screen and (max-width: 767px) {
    .date-container .row input { width: 100%; }
  }
`;

export const Input = styled.input`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  padding: 10px;
  margin-bottom: 15px;
  background-color: ${colors.white};
  -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  border-radius: 8px;
  border: ${(props) => {
    if (props.error) return `1px solid ${colors.red}`;
    if (props.onFocusInput) return `1px solid ${colors.primary}`;
    return `1px solid ${colors.white}`;
  }};
  outline: none;
`;
